import { FC } from 'react';

export const ArrowCornerSvg: FC<{ clr: string, opacity?: string }> = ({ clr = "#909090" }) => {

  return (
    <svg width="25" height="24" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M6.39398 18.1784C6.36582 18.2066 6.35 18.2447 6.35 18.2845C6.35 18.3243 6.36582 18.3625 6.39398 18.3906L7.61057 19.6061C7.66914 19.6646 7.76404 19.6646 7.82261 19.6061L16.6578 10.779L16.6578 17.4227C16.6578 17.4626 16.6738 17.5009 16.7021 17.5291C16.7305 17.5572 16.7689 17.5729 16.8088 17.5726L18.501 17.5616C18.5834 17.5611 18.65 17.4941 18.65 17.4116L18.65 7.51105C18.65 7.42827 18.5829 7.36114 18.5002 7.36105L8.57943 7.35C8.53945 7.34996 8.50111 7.36587 8.47291 7.39422C8.44472 7.42256 8.42901 7.46099 8.42927 7.50097L8.44033 9.21368C8.44086 9.29623 8.508 9.36284 8.59056 9.36271L15.2283 9.35223L6.39398 18.1784Z"
        fill={clr} stroke={clr} strokeWidth="0.3" strokeLinejoin="round"/>
    </svg>
  )
}

import { FC } from 'react';

export const ArrowCornerSvg: FC<{ clr: string, opacity?: string }> = ({ clr = "#909090" }) => {

  return (
    <svg width="25" height="24" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M6.39398 18.1784C6.36582 18.2066 6.35 18.2447 6.35 18.2845C6.35 18.3243 6.36582 18.3625 6.39398 18.3906L7.61057 19.6061C7.66914 19.6646 7.76404 19.6646 7.82261 19.6061L16.6578 10.779L16.6578 17.4227C16.6578 17.4626 16.6738 17.5009 16.7021 17.5291C16.7305 17.5572 16.7689 17.5729 16.8088 17.5726L18.501 17.5616C18.5834 17.5611 18.65 17.4941 18.65 17.4116L18.65 7.51105C18.65 7.42827 18.5829 7.36114 18.5002 7.36105L8.57943 7.35C8.53945 7.34996 8.50111 7.36587 8.47291 7.39422C8.44472 7.42256 8.42901 7.46099 8.42927 7.50097L8.44033 9.21368C8.44086 9.29623 8.508 9.36284 8.59056 9.36271L15.2283 9.35223L6.39398 18.1784Z"
        fill={clr} stroke={clr} strokeWidth="0.3" strokeLinejoin="round"/>
    </svg>
  )
}

